/******************************************************************************
 * 
 * Strauss Motion
 * 
 * Copyright (c) 2022 Robimo GmbH
 *
 * Authors: Daniel Martinek
 *
 *****************************************************************************/

import React, { Fragment, useState } from 'react';
import EditscreenContainer from '../containers/EditscreenContainer';
import CustomerscreenContainer from '../containers/CustomerscreenContainer';
import PostscreenContainer from '../containers/PostscreenContainer';
import SplashscreenContainer from '../containers/SplashscreenContainer';
import LanguageSwitcherContainer from '../containers/LanguageSwitcherContainer';
import {isMobile, useMobileOrientation } from 'react-device-detect';

import styles from '../styles/app.module.scss'
import { LogoText } from './LogoText';
import { useTranslation } from 'react-i18next';
import { LibraryData } from '../store/interfaces';
import NotfoundscreenContainer from '../containers/NotfoundscreenContainer';
import InspirationscreenContainer from '../containers/InspirationscreenContainer';
import OrderscreenContainer from '../containers/OrderscreenContainer';
import FinalscreenContainer from '../containers/FinalscreenContainer';

interface AppProps {
    route: string;
    library: LibraryData;
    showCountryChangeInfo: boolean;
    onUiShowCountryChangeInfo: (showCountryChangeInfo: boolean) => void;
}

interface CountryChangeInfoProps {
    onUiShowCountryChangeInfo: (showCountryChangeInfo: boolean) => void;
}

function MobileLandscape() {
    const {t} = useTranslation();
    return (
        <div className={styles.container}>
            <div className={styles.center}>
                <LogoText size={'medium'} center/>
                <p className={styles.info}>{t('mobile.landscape')}</p>
                <LanguageSwitcherContainer/>
            </div>
        </div>
    );
}
function getCookie(cookieName: string) {
    let name = cookieName + "=";
    let spli = document.cookie.split(';');
    for(var j = 0; j < spli.length; j++) {
      let char = spli[j];
      while (char.charAt(0) === ' ') {
        char = char.substring(1);
      }
      if (char.indexOf(name) === 0) {
        return char.substring(name.length, char.length);
      }
    }
    return "";
}

/*
function CookieBar() {
    const {t} = useTranslation();

    let cookie = getCookie('cookiebar');
    const [isCookiebarVisible, setCookiebarVisible] = useState(cookie === '');

    if(!isCookiebarVisible) {
        return null;
    }

    return <div className={styles.cookieBar}>
        <p dangerouslySetInnerHTML={{__html: t('cookie.message')}}></p>
        <button className={`${styles.button} ${styles.buttonSmall} ${styles.buttonPrimary}`} onClick={() => {
            document.cookie = "cookiebar=1";
            setCookiebarVisible(false);
        }}>{t('cookie.ok')}</button>
    </div>
}
*/

function CountryChangeInfo(props: CountryChangeInfoProps) {
    const {t} = useTranslation();

    return <div className={styles.modalBackground}>
        <div className={styles.modal}>
            <h1>{t('country.title')}</h1>
            <hr/>
            <p>{t('country.text')}</p>
            <div className={styles.buttonContainer}>
                <button className={`${styles.button} ${styles.buttonPrimary}`} onClick={() => {
                    props.onUiShowCountryChangeInfo(false);
                }}>{t('country.close')}</button>
            </div>
        </div>
    </div>
}

export function App(props: AppProps) {
    const { isLandscape } = useMobileOrientation();
    if(isMobile && isLandscape) {
        return <MobileLandscape/>;
    }

    let routeElement = null;
    switch (props.route) {
        case 'splashscreen':
            routeElement = <SplashscreenContainer/>;
            break;
        case 'editscreen':
            routeElement = <EditscreenContainer/>;
            break;
        case 'orderscreen':
            routeElement = <OrderscreenContainer/>;
            break;
        case 'customerscreen':
            routeElement = <CustomerscreenContainer/>;
            break;
        case 'finalscreen':
            routeElement = <FinalscreenContainer/>;
            break;
        case 'postscreen':
            routeElement = <PostscreenContainer/>;
            break;
        case 'inspiration':
            routeElement = <InspirationscreenContainer/>;
            break;
        default:
            routeElement = <NotfoundscreenContainer/>;
            break;
    }

    return <Fragment>
        {routeElement}
        {props.showCountryChangeInfo && <CountryChangeInfo onUiShowCountryChangeInfo={props.onUiShowCountryChangeInfo}/>}
        {/*<CookieBar/>*/}
    </Fragment>
}